module.exports = __webpack_public_path__ + "img/lampBlack.f45e4204.gif";